import styled from 'styled-components';

export const InsideModal = styled.div`
  padding: 1rem;

  ul {
    padding: 0 1rem;
    margin: 0 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
`;

export const PermissionModalButton = styled.button<{ variant: 'primary' | 'secondary' }>`
  background-color: ${(props) => (props.variant === 'primary' ? '#ff5722' : '#f5f5f5')};
  color: ${(props) => (props.variant === 'primary' ? 'white' : '#ff5722')};
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;

  &:hover {
    background-color: ${(props) => (props.variant === 'primary' ? '#ff6d42' : '#e0e0e0')};
  }
`;
